import CrudV1 from "../../../../components/form_builder/elements/crud/CrudV1.vue";

export default {
  componentName: "fb-crud-v1",
  component: CrudV1,
  defaultAttrs: {
    properties: {
      formLayout: {
        rows: []
      },
      listItemLayout: {
        rows: []
      },
      listHeaderContent: "",
      label: "Label",
      labelStyle: {},
      listItemStyle: {},
      listItemDeleteStyle: {},
      formStyle: {},
      addRecordLabelStyle: {},
      addRecordLabel: "Add Record",
      removeRecordLabel: "",
      addEmptyRecord: false,
      hidden: false
    }
  },
  gridAttrs: {
    type: "template",
    width: 120,
    template: () => ""
  },
  validate: () => {
    const errors = [];
    return errors;
  }
};
